<template>
  <div v-loading="loading">
    <el-table
      class="outstanding-table"
      v-if="tableConfig"
      :key="tableKey"
      :data="outstandings"
      style="width: 100%"
      row-key="id"
      border
      show-summary
      :summary-method="getSum"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="80"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="outstanding"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :outstanding="scope.row" />
        </template>
      </el-table-column>
      <template slot="append">

      </template>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        itemLoading: 0,
        currentSort: {
          prop: 'gross_price',
          order: 'desc',
        },
      };
    },
    computed: {
      outstandings() {
        return this.$store.getters['outstanding/outstandings'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['outstanding/tableConfig']));
      },
      loading() {
        return this.$store.getters['outstanding/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('outstanding/setFilterString', '');
      this.$store.commit('outstanding/setSorting', this.currentSort);
      await this.$store.dispatch('outstanding/fetchAll');
    },
    methods: {
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('outstanding/setSorting', { prop, order });
          this.$store.dispatch('outstanding/fetchAll');
        }
      },
      getSum(params) {
        let result = [];
        let netSum = 0;
        let grossSum = 0;
        params.data.forEach(outstanding => {
          netSum += outstanding.net_price;
          grossSum += outstanding.gross_price;
        });
        result = params.columns.map((column, index) => {
          if(index === 0) {
            return 'Össz.:';
          }
          if(column.property === 'net_price') {
            return this.$options.filters.currency(netSum.toFixed(2));
          }
          if(column.property === 'gross_price') {
            return this.$options.filters.currency(grossSum.toFixed(2));
          }
          return '';
        });
        return result;
      },
    },
  };
</script>
<style lang="scss">
  .outstanding-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
